import { Address } from "@/api/model"

const titleCaseWords = (line: string) =>
  line
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      /\d/.test(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ")

export const buildAddressLine1 = (address: Address) =>
  titleCaseWords(address.addressLine1)

export const buildFullAddressLine = (address: Address) => {
  const addressLines = [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
  ]
    .filter(Boolean)
    .map((line) => titleCaseWords(line!))

  return [...addressLines, address.postcode].join(", ")
}
